import type { HTMLAttributes } from "react";
import { cx } from "@/lib/cx";

export type RuleProps = HTMLAttributes<HTMLDivElement> & {
  orientation?: "horizontal" | "vertical";
  tone?: "hairline" | "strong" | "ink";
  /** Inset a horizontal rule by the page gutter. */
  inset?: boolean;
};

const tones = {
  hairline: "bg-border-hairline",
  strong: "bg-border-strong",
  ink: "bg-border-ink",
} as const;

export function Rule({ orientation = "horizontal", tone = "hairline", inset = false, className, ...rest }: RuleProps) {
  const vertical = orientation === "vertical";
  return (
    <div
      role="separator"
      aria-orientation={orientation}
      className={cx(
        tones[tone],
        vertical ? "w-px h-[1em] self-center flex-none" : "w-auto h-px",
        inset && !vertical && "mx-gutter",
        className,
      )}
      {...rest}
    />
  );
}
